
export const demo_cards = [
    {id: 0, title: 'Upper'},
    {id: 1, title: 'Lower'},
    {id: 2, title: 'Upper'},
    {id: 3, title: 'Lower'}
]

export const demo_split = ['Upper', 'Lower', 'Rest', 'Upper', 'Rest', 'Lower', 'Rest']

export const demo_rows = {
    0: [
        {id: 0, text: ['bench', '3 x 6', '225'], tagNo: 0},
        {id: 1, text: ['lat pull down', '3 x 10', '160'], tagNo: 0},
        {id: 2, text: ['ez bar curl', '3 x 8', '80'], tagNo: 0},
        {id: 3, text: ['tricep pressdown', '3 x 12', '100'], tagNo: 0},
        {id: 4, text: ['lat raise', '3 x 10', '30s'], tagNo: 0},
        {id: 5, text: ['rear delt raise', '3 x 10', '25s'], tagNo: 0}
    ],
    1: [
        {id: 0, text: ['squat', '4 x 5', '315'], tagNo: 0},
        {id: 1, text: ['rdl', '3 x 8', '155'], tagNo: 0},
        {id: 2, text: ['leg extensions', '3 x 12', '240'], tagNo: 0},
        {id: 3, text: ['seated leg curl', '3 x 10', '180'], tagNo: 0},
        {id: 4, text: ['seated calf raise', '4 x 14', '115'], tagNo: 0}
    ],
    2: [
        {id: 0, text: ['oh press', '3 x 8', '115'], tagNo: 0},
        {id: 1, text: ['dumbbell chess press', '3 x 8', '80s'], tagNo: 0},
        {id: 2, text: ['lat row', '3 x 12', '160'], tagNo: 0},
        {id: 3, text: ['hammer curl', '3 x 10', '35s'], tagNo: 0},
        {id: 4, text: ['skull crusher', '3 x 12', '90'], tagNo: 0},
        {id: 5, text: ['cable lat raise', '3 x 14', '20'], tagNo: 0}
    ],
    3: [
        {id: 0, text: ['hack squat', '3 x 8', '200'], tagNo: 0},
        {id: 1, text: ['glute bridge', '3 x 10', '225'], tagNo: 0},
        {id: 2, text: ['leg press', '3 x 14', '400'], tagNo: 0},
        {id: 3, text: ['lying leg curl', '3 x 10', '140'], tagNo: 0},
        {id: 4, text: ['standing calf raise', '4 x 14', '225'], tagNo: 0}
    ]
    
}

export const demo_bars = [{title: 'calories', value: 0, id: 1, goal: 2000},
{title: 'protein', value: 0, id: 2, goal: 56}]